import { useState } from 'react';
import Collapse from '../../../collapse/Collapse';
import DishCreatorHeader from "./dishHeader/DishCreatorHeader";
import DishInfoCreator from "./dishInfo/DishInfoCreator";
import PropTypes from "prop-types";
import { getDishId } from "../../../../../utils/model/dish";

const DishCreator = ({dish, onDishChange, onRemoveClick, index}) => {
    const [expanded, setExpanded] = useState(false);
    const handleExpand = () => {
        if (!expanded) {
            setExpanded(true);
        }
    }

    const handleClose = () => {
        setExpanded(false);
    }

    return (
        <Collapse
            id="collapsible-dish"
            expanded={expanded}
            onClick={handleExpand}
            onClose={handleClose}
            closePosition="top"
            renderHeader={() => (
                <DishCreatorHeader
                    id={getDishId(dish)}
                    name={dish.name}
                    index={index}
                    expanded={expanded}
                    onRemoveClick={onRemoveClick}
                />
            )}
            renderContent={() => (
                <DishInfoCreator
                    onDishChange={onDishChange}
                    dish={dish}
                />
            )}
        />
    );
}

DishCreator.propTypes = {
    index: PropTypes.number.isRequired,
    dish: PropTypes.object.isRequired,
    onDishChange: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired
};

export default DishCreator;
